export type CsvHeader = { label: string; key: string };

const escapeCsvValue = (value: any) => {
  if (value === null || value === undefined) return '';
  const text = String(value);
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

export const buildCsv = (headers: CsvHeader[], rows: Record<string, any>[]) =>
  [
    headers.map((header) => escapeCsvValue(header.label)).join(','),
    ...rows.map((row) => headers.map((header) => escapeCsvValue(row[header.key])).join(',')),
  ].join('\r\n');

// builds the csv and triggers a browser download. the BOM makes Excel read it as UTF-8 (e.g. £)
export const downloadCsv = (
  headers: CsvHeader[],
  rows: Record<string, any>[],
  filename: string,
) => {
  const blob = new Blob(['\uFEFF', buildCsv(headers, rows)], {
    type: 'text/csv;charset=utf-8;',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
